<div class="ax-dialog__container" #containerElement>
    <ng-template ax-dialog></ng-template>
</div>
